module.exports = __webpack_public_path__ + "static/media/icons.72c701d7.eot";